/**
 * pathName:请求路径，直接取最后一级，比如请求是http://storetest.p8go.cn/shopApi/product/queryList,
 *    则该pathName为/queryList；如果是类似此类请求链接http://storetest.p8go.cn/shopApi/product/，
 *    则该pathName为/
 * shopCode:商家代号，获取方式，在进入商城获取基础授权信息时的请求参数即为商家代号，同时，系统生成的相关授权
 *    Token也是由商家代号开头，Token是由两个部分组成，商家代号和随机秘钥，两者用连接符（"-"）进行拼接；
 * 生成签名的函数中存在大量魔法值，比如headers-,miles-,path-等，建议将这些魔法值单独保存到store或者其他
 *  地方，避免可以直接了解生成签名规则具体参数
 * 访问签名secret加密，需要引入js-md5依赖
 */

/**ç
 * 生成访问签名
 * @param {Object} pathName 请求路径
 * @param {Object} shopCode 商家代号
 * @param {Object} requestAuthor 商家授权Token，如果没有获取到，该参数传入null
 * return 生成签名的格式 随机数-毫秒数-商家代号-访问签名secret
 */
import md5 from 'js-md5';
import axios from 'axios';
import global from "./common";
//获取服务器时间
function getNowTime() {
  var nowTime = new Date().getTime();
  axios.get(global.url + '/soft/shopApi/common/getSystemMiles').then(res => {
    console.log("我在前面",nowTime)
    if (res.data.code == 200) {
      nowTime = res.data.data;
    } else {
      nowTime = new Date().getTime();
    }
  });
  return nowTime
}
//登陆板块接口地址加密
export function getRequestSign(pathName, shopCode, requestAuthor) {
  var random = "";
  for (let i = 0; i < 6; i++) {
    random += Math.floor(Math.random() * 10);
  }
  var timeMiles =  new Date().getTime();
  // console.log("我在后面",new Date().getTime());
  var sign = random.toString().concat("-").concat(timeMiles).concat("-").concat(shopCode);
  var str = "";
  if (requestAuthor != null) {
    str = "header-" + requestAuthor.substring(8);
  }
  str = str.concat("miles-" + timeMiles).concat("path-" + pathName)
    .concat("randomNum-" + random.toString().substring(1, 5)).concat("shopCode-" + shopCode);
  //模拟MD5加密，vue项目需引入js-md5
  var signSecret = md5(str);
  return sign.concat("-" + signSecret);
};



// WEBPACK FOOTER //
// ./src/api/sign.js